<template>
    <div>

        <div class="d-flex justify-content-center my-5">

<!--            <calendar-filter-button class="btn-app-blue"-->
<!--                                    lang="Spanish" course="TrainingQuarter" type="course" label="ET Spanish Class"-->
<!--                                    v-model="filters" @click="applyFilter"></calendar-filter-button>-->

            <calendar-filter-button class="btn-app-red mr-2"
                                    lang="Spanish" course="Course" type="lab" label="Spanish Labs"
                                    v-model="filters" @click="applyFilter"></calendar-filter-button>

            <calendar-filter-button class="btn-app-yellow"
                                    lang="English" course="Course" type="lab" label="English Labs"
                                    v-model="filters" @click="applyFilter"></calendar-filter-button>

<!--            <calendar-filter-button class="btn-app-green"-->
<!--                                    lang="English" course="Course"  type="course"label="English CEU Courses"-->
<!--                                    v-model="filters" @click="applyFilter"></calendar-filter-button>-->

        </div>

        <schedule-information-modal :schedule="currentSchedule" v-if="currentSchedule"></schedule-information-modal>

        <div id="schedule-calendar" class="calendar"></div>

    </div>
</template>
<script>

    import SchedulesCalendar from '@/mixins/SchedulesCalendar'

    export default {

        mixins: [SchedulesCalendar],

        data() {
            return {
                schedules: [],
                currentEvent: null,
                currentSchedule: null,
                filters: {
                    lang: '',
                    course: '',
                    type: '',
                },
            }
        },

        methods: {
            fetchSchedules(info, successCallback, failureCallback) {
                this.fetchClosedDays()
                App.request().get(`/api/calendar`, {
                    params: {
                        from: moment().add(1, 'day').format(),
                        to: info.end,
                        lang: this.filters.lang,
                        type: this.filters.type,
                        course: this.filters.course,
                    }
                }).then(response => {
                    this.events = this.mapSchedules(response.data.schedules)
                    successCallback(this.events);
                })
            },

            onEventClick(event) {
                this.currentEvent = event;
                this.currentSchedule = event.extendedProps.schedule;

                this.$nextTick(() => {
                    this.openModal('schedule-information-modal')
                })
            },

            applyFilter(course, lang, type) {
                if (this.filters.course == course && this.filters.lang == lang && this.filters.type == type) {
                    this.filters.course = '';
                    this.filters.lang = '';
                    this.filter.type = '';
                } else {
                    this.filters.course = course;
                    this.filters.lang = lang;
                    this.filters.type = type;
                }
                this.calendar.refetchEvents();
            },

        },
    }
</script>
